// Import necessary dependencies and utilities
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const teamResourcePlanningAPI = createApi({
    reducerPath: "teamResourcePlanningAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getteamResourceplanning: builder.query({
            query: ({ teamId, planningId }) => ({
                url: `TeamResourcePlanning/GetTeamResourcePlanningListByTeamIdAndPlanningId?TeamId=${teamId}&PlanningId=${planningId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addteamResourceplanning: builder.mutation({
            query: (data) => ({
                url: `/TeamResourcePlanning/AddTeamResourcePlanning`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateteamResourceplanning: builder.mutation({
            query: (data) => ({
                url: `TeamResourcePlanning/UpdateTeamResourcePlanning`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteteamResourceplanning: builder.mutation({
            query: (data) => ({
                url: `TeamResourcePlanning/DeleteTeamResourcePlanningById?ResourcePlanningId=${data.resourcePlanningId}&TeamId=${data.teamId}&UserId=${data.userId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Get All ResourcePlanningList 
        getAllResourcePlanningList: builder.query({
            query: ({ teamId, planningId }) => ({
                url: `TeamResourcePlanning/GetAllResourcePlanningList?TeamId=${teamId}&PlanningId=${planningId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getResourceTotalPlanningCount:builder.query({
            query:({teamId,planningId}) => ({
                url:`TeamResourcePlanning/GetResourceTotalPlanningCount?TeamId=${teamId}&PlanningId=${planningId}`,
                method:'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetResourcePlanningDetailsList: builder.query({
            query: ({ teamId, planningId }) => ({
                url: `TeamResourcePlanning/GetResourcePlanningDetails?TeamId=${teamId}&PlanningId=${planningId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const {
    useLazygetteamResourceplanningQuery,
    useAddteamResourceplanningMutation,
    useUpdateteamResourceplanningMutation,
    useDeleteteamResourceplanningMutation,
    useLazyGetAllResourcePlanningListQuery,
    useLazyGetResourceTotalPlanningCountQuery,
    useLazyGetResourcePlanningDetailsListQuery
} = teamResourcePlanningAPI;

export default teamResourcePlanningAPI;